

































































import { Question } from '@/resource/question/question.model';
import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import QuestionBankItem from './question-bank-item/QuestionBankItem.vue';
import QuestionBankItemLoading from './question-bank-item/QuestionBankItemLoading.vue';
import QuestionBankNotFound from './QuestionBankNotFound.vue';
import ModalGoogleForm from '@/main-components/common/modal/ModalGoogleForm.vue';
import { getEmail } from '@/utils/cookie';
import { FetchQuestionsParams } from '@/resource/question/questions.store';
import { Subject } from '@/resource/subject/subject.model';
import onScrollView from '@/utils/common/on-scroll-view';
import { OnSubmitReturn } from '@/utils/form/form-input-typing';
import { getUserStatus } from '@/utils/cookie';
import { UserStatus } from '@/resource/user/user.model';
import QuestionBankNeedMore from './question-bank-item/QuestionBankNeedMore.vue';
import PremiumModal from '@/main-components/premium/PremiumModal.vue';

@Component({
  components: {
    QuestionBankItem,
    QuestionBankItemLoading,
    QuestionBankNotFound,
    QuestionBankNeedMore,
    ModalGoogleForm,
    PremiumModal,
  },
})
export default class QuestionBankContent extends Vue {
  @Prop({ default: [] })
  questions: Question[];

  @Prop({ required: true })
  selectedSubject: Subject;

  @Prop({ required: true })
  questionsFilter: FetchQuestionsParams;

  @Prop({ required: true })
  isSubjective: boolean;

  @Prop({ required: true })
  isLoading: boolean;

  @Prop({ required: true })
  isLastPage: boolean;

  @Prop({ required: true })
  questionCount: number | null;

  @Prop({ required: true })
  fetchQuestions: (
    isResetPagination: boolean,
  ) => Promise<OnSubmitReturn | null>;

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get showNeedMoreQuestions() {
    return this.userStatus === UserStatus.Free && this.isLastPage
      ? true
      : false;
  }

  get premiumModalDescription() {
    if (this.questionCount) {
      return `Lihat kesemua <span class="text-brand_dark-primary">${this.questionCount}</span> soalan dengan melanggan pelan premium kami.`;
    } else {
      return 'Dapatkan soalan tanpa had di bank soalan dengan melanggan PREMIUM.';
    }
  }

  isQuestionBankItemLoading = false;

  openReqSubjectModal: any = null;
  openReqQuestionsModal: any = null;
  openPremiumModal: any = null;
  scrollBottomObserver: IntersectionObserver | null = null;

  get userEmail() {
    return getEmail() || '';
  }

  get reqMoreQuestionsGoogleForm() {
    return `https://docs.google.com/forms/d/e/1FAIpQLSeezf3L03-wtwRaChqU2Y3gFon-HoOcGseaAk7dGCQpmzS2uQ/viewform?embedded=true&usp=pp_url&entry.599702293=${this.questionsFilter.subjectUuid}&entry.293032722=${this.questionsFilter.chapterIds}&entry.732831280=${this.userEmail}`;
  }

  get reqSubjectGoogleForm() {
    return `https://docs.google.com/forms/d/e/1FAIpQLSetIYYwFa_Im9lx-6eokp6ZqWB6Zxp0HbMPk-hbi1b2Zf0cLA/viewform?embedded=true&usp=pp_url&entry.599702293=${this.questionsFilter.subjectUuid}&entry.732831280=${this.userEmail}`;
  }

  get isSubjectNotAvail() {
    if (!this.selectedSubject) {
      return false;
    }

    if (
      !this.selectedSubject.isAvailLowerForm &&
      !this.selectedSubject.isAvailUpperForm &&
      !this.selectedSubject.isAvailElementary
    ) {
      return true;
    }

    return false;
  }

  get endElement() {
    return document.getElementById('end-question-bank');
  }

  @Provide('toggleIsQuestionBankItemLoading')
  async toggleIsQuestionBankItemLoading(value: boolean) {
    this.isQuestionBankItemLoading = value;
  }

  openReqSubjectModalAdd(openModal: any) {
    this.openReqSubjectModal = openModal;
  }

  openReqQuestionsModalAdd(openModal: any) {
    this.openReqQuestionsModal = openModal;
  }

  openPremiumModalAdd(openModal: any) {
    this.openPremiumModal = () => {
      this.$sendMpEvent({
        event: this.$mp_value.SubscriptionShowAllQuestionClick,
      });
      openModal && openModal();
    };
  }

  mounted() {
    this.observeScrollBottom();
  }

  beforeDestroy() {
    this.unobserveScrollBottom();
  }

  observeScrollBottom() {
    if (this.endElement) {
      this.scrollBottomObserver = onScrollView(this.endElement, () => {
        this.questions.length && this.fetchQuestions(false);
      });
    }
  }

  unobserveScrollBottom() {
    if (this.scrollBottomObserver && this.endElement) {
      this.scrollBottomObserver.unobserve(this.endElement);
    }
  }
}
